import React, { useEffect, useState } from 'react'
import { Box, Grid, Collapse, Avatar, useMediaQuery, Theme } from '@mui/material'
import HtmlReactParser from 'html-react-parser'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../components'
import { img } from '../../imgs'
import { useReduxSelector } from '../../hooks'

export const ManagerModal: React.FC<{ item: any; show: boolean; onClose: () => any; className: any }> = ({
  item = [],
  className,
  show = false,
  onClose = () => {},
}): JSX.Element => {
  const navigate = useNavigate()

  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const { REACT_APP_URL: URL } = process.env

  const { data: constants } = useReduxSelector((state) => state.constants)

  const [collapse, setCollapse] = useState<boolean>(true)

  const onCloseModal = () => {
    onClose()
    setCollapse(false)
  }

  useEffect(() => {
    if (!collapse) {
      setTimeout(() => setCollapse(true), 200)
    }
  }, [collapse])

  return (
    <Modal maxWidth="md" open={show} onClose={onCloseModal}>
      <Collapse in={collapse}>
        <Box mt={3}>
          <Grid container justifyContent="center">
            <Grid item>
              <Avatar
                className={className.avatar}
                src={constants?.PROFILE === 'prod' ? `${URL}${item.popupSrc}` : `${URL}${item.popupSrc}`}
                alt=""
                sx={{ width: sm ? 190 : 250, height: sm ? 190 : 250 }}
              />
            </Grid>
          </Grid>
          <Box textAlign="center" className={className.managerTitleModal}>
            {item.popupTitle}
          </Box>
          <Box textAlign="center" className={className.managerPositionModal}>
            {item.popupPosition}
          </Box>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={9}>
              <Box className={className.managerBodyModal}>{item.popupBody}</Box>
            </Grid>
          </Grid>
          <Box className={className.managerLinkModal} onClick={() => navigate(`../media/${item.id}?market`)}>
            Посмотреть контент
          </Box>
        </Box>
      </Collapse>
    </Modal>
  )
}
